import fabrica1 from "../images/fabrica-slide/fabrica-slide1.jpg"
import fabrica2 from "../images/fabrica-slide/fabrica-slide2.jpg"

export default [fabrica1, fabrica2]
